module.exports = __webpack_public_path__ + "img/header-bg.f6ccd958.jpg";